import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DispatchContext from '../DispatchContext';
import Register from './Register';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useContext(DispatchContext);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await fetch('https://backend.alephmedia.ro/api/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'include',
                body: JSON.stringify({ email, password })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Autentificare eșuată');
            }

            const data = await response.json();
            
            // Salvăm token-ul și datele utilizatorului
            localStorage.setItem('authToken', data.token);
            localStorage.setItem('userData', JSON.stringify({ name: data.name }));
            
            // Actualizăm starea aplicației
            dispatch({ type: "userLoggedIn", payload: { name: data.name } });
            
            // Afișăm notificarea
            dispatch({ 
                type: "newEvent", 
                value: {
                    header: "Autentificare reușită",
                    message: "Bine ați revenit!",
                    link: "/"
                }
            });
            
            // Redirecționăm către pagina principală
            navigate('/');
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-container">
                <h1 className="auth-title">Autentificare</h1>

                {error && <p className="error">{error}</p>}
                {loading && <p className="loading">Se procesează...</p>}

                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-field"
                            placeholder="Email"
                            required
                        />
                    </div>
                    <div className="form-row">
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-field"
                            placeholder="Parolă"
                            required
                        />
                    </div>
                    <div className="form-row">
                        <button
                            type="submit"
                            className="form-submit"
                            disabled={loading}
                        >
                            {loading ? 'Se procesează...' : 'Autentificare'}
                        </button>
                    </div>
                </form>

                <a href="/register" className="auth-link">
                    Nu aveți cont? Înregistrați-vă
                </a>
            </div>
        </div>
    );
}

export default Login;